export default __webpack_public_path__ + "static/media/april-2019-school-day.3d744e13.csv";